import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { PulseLoader } from 'halogenium';
import './AddNewMembershipModal.scss';
import MembershipRepository from '../../app/Merchant/Repository/MembershipRepository';
import MerchantSettingKey from '../../app/Common/Enum/MerchantSettingKey';
import MembershipBenefitRepository from "../../app/Merchant/Repository/MembershipBenefitRepository";
var portalRoot = null;

class AddNewMembershipModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#add-new-membership-modal').length == 0) {
            const content = '<div id="add-new-membership-modal" class="add-new-membership-modal" style="position:absolute; z-index:1501"></div>'
            if ($('#select-membership-modal').length > 0) {
                // Add this after #select-membership-modal, else will be at behind and blocked by #select-membership-modal
                $('#select-membership-modal').after(content)
            }
            else {
                $('body').prepend(content)
            }
        }
        portalRoot = document.getElementById("add-new-membership-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}

class AddNewMembershipModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            membership: this.initMembership(),
            errors: {},
            membershipBenefits: [],
        }
        this.modalId = "add-new-membership-bs-modal"
        this.callbackKey = "AddNewMembershipModal"
    }
    initMembership = () => {
        if (this.props.membership && this.props.membership.id) {
            return {
                ...this.props.membership
            }
        }
        else {
            return {
                minimum_redeem_point: this.props.app.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_MINIMUM_REDEEM_POINT),
                maximum_redeem_point: this.props.app.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_MAXIMUM_REDEEM_POINT),
                redeem_rate: this.props.app.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_DEFAULT_REDEEM_RATE),
                earn_rate: this.props.app.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_DEFAULT_EARN_RATE),
            }
        }
    }
    isLoading(isLoading, callback) {
        if (!this.unmounted) {
            this.setState({isLoading}, () => {callback && callback()})
        }
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
        this.clearTimer()
        MembershipBenefitRepository.getInstance().removeCallback(null, this)
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onYes && this.props.onYes()
            }
        }
        this.escListener = (event) => {
            let a = this.unmounted
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onNo && this.props.onNo()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);

        if (this.props.autoShow && this.modalId) {
            $('#'+this.modalId)
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', () => {
                this.props.onModalClosed && this.props.onModalClosed()

                // https://stackoverflow.com/a/24914782
                // Fix double bootstrap modal issue where after the top most modal is closed,
                // the remaining modal unable to scroll
                $('.modal:visible').length && $(document.body).addClass('modal-open')
            })
            .modal();
        }

        $('#'+ this.modalId)
            .off('show.bs.modal')
            .on('show.bs.modal', function() {
                const zIndex = 1040 + 10 * $('.modal:visible').length;
                $(this).css('z-index', zIndex);
                setTimeout(() => $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack'));
            });

        // $(document).on('show.bs.modal', `#${this.modalId}.modal`, function() {
        //     const zIndex = 1040 + 10 * $('.modal:visible').length;
        //     $(this).css('z-index', zIndex);
        //     setTimeout(() => $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack'));
        // });

        // We can intercept the modal before close event to "cancel" closing of
        // the modal
        $('#'+ this.modalId)
            .on('hide.bs.modal', () => {
                return this.attemptCloseModal()
            })

        MembershipBenefitRepository.getInstance().loadAll((membershipBenefits) => {
            this.setState({membershipBenefits})
        }, this.callbackKey, this)
    }
    attemptCloseModal = () => {
        if (!this.checkAllowCloseModal(this.forceClose)) {
            return false
        }
        this.props.onNo && this.props.onNo()
        return true
    }
    forceClose = () => {
        this.close(true)
    }
    // Parent to call this to dismiss the modal
    close = (forceClose) => {
        if (forceClose) {
            this.removeOnHideListener()
        }
        $('#'+this.modalId).modal('hide')
    }
    clearTimer = () => {
        if (this.errorTimer) {
            clearTimeout(this.errorTimer)
        }
    }
    onYes = () => {
        let membershipData = {...this.state.membership}

        let required = {
            // DataKey : Label
            membership_number   : lang.membership_card_no,
            name                : lang.name,
            phone_number        : lang.phone_number,
        }

        let errors = {}
        let hasError = false
        let errorKeyToRemove = []
        Object.keys(required).forEach(key => {
            if (!membershipData[key]) {
                errorKeyToRemove.push(key)
                errors[key] = `"${required[key]}" ${lang.required_field.toLowerCase()}`
                hasError = true
            }
        })

        this.setError(errors, errorKeyToRemove)

        // this.setState({
        //     errors
        // }, () => {
        //     this.clearTimer()
        //     this.errorTimer = setTimeout(() => {
        //         this.setState({
        //             errors: {},
        //         })
        //     }, 5000);
        // })

        if (hasError) {
            return
        }

        if (this.state.starting_point) {
            membershipData.starting_point = this.state.starting_point
        }

        this.setState({
            isSaving: true
        }, () => {
            MembershipRepository.getInstance()
            .validate(membershipData)
            .then( (repository) => {
                repository.save(membershipData, (savedMembership) => {
                    // Small delay to wait for 'always' to fire first
                    setTimeout(() => {
                        this.props.onYes && this.props.onYes(savedMembership)
                    }, 200);
                }, () => {
                    this.setState({
                        isSaving: false,
                        isEdited: false,
                    })
                })
            })
            .catch(err => {
                alert(err.message)
                if (err.code == 1000) {
                    let errors = {...this.state.errors}
                    errors["membership_number"] = err.message
                    this.setError(errors, ["membership_number"])
                }
                this.setState({
                    isSaving: false,
                })
            })
        })
    }

    onCancelClicked = () => {
        $('#'+this.modalId).modal('hide')
    }
    getButtons = () => {
        return (
            <div style={{display: "flex"}}>
                <div style={{flex: "1 0 100px", textAlign: "right"}}>
                    <button onClick={this.attemptCloseModal} className="btn btn-danger btn-sm mr-2">{this.props.noText || lang.cancel}</button>
                    <button onClick={this.onYes} className="btn btn-success btn-sm">{this.props.yesText || lang.confirm}</button>
                </div>
            </div>
        )
    }
    removeOnHideListener = () => {
        $('#'+ this.modalId)
            .off('hide.bs.modal')
    }
    checkAllowCloseModal = (closeModal) => {
        if (this.state.isEdited) {
            if (confirm(lang.changes_not_saved_sure_to_close)) {
                if (closeModal) {
                    setTimeout(closeModal, 200)
                }
            }
            return false
        }
        else if (this.state.isSaving) {
            return false
        }
        return true
    }
    onClose = () => {
        this.props.onClose && this.props.onClose()
    }
    handleInputData = (e) => {
        let value = e.target.value
        let invalidPhoneCharacter = ""
        if (e.target.name == 'phone_number') {
            let match = value.match(/[^\d+-]/g)
            value = value.replace(/[^\d+-]/g, '')
            if (match && match.length) {
                invalidPhoneCharacter = match[0]
            }
        }
        return {
            value, invalidPhoneCharacter
        }
    }
    onMembershipChange = (e) => {
        let { value, invalidPhoneCharacter, } = this.handleInputData(e)
        let errors = {...this.state.errors}
        if (invalidPhoneCharacter) {
            errors["phone_number"] = lang.invalid_phone_character.replace('%character%', invalidPhoneCharacter)
        }
        this.setState({
            isEdited: true,
            membership: {
                ...this.state.membership,
                [e.target.name]: value,
            },
        }, () => {
            this.setError(errors, ["phone_number"])
        })
    }

    onOtherInfoChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    setError = (errors, keyToRemoveAfterTimeout) => {
        this.clearTimer()
        this.setState({errors})
        this.errorTimer = setTimeout(() => {
            let errors = {...this.state.errors}
            keyToRemoveAfterTimeout.forEach(key => {
                delete(errors[key])
            })
            this.setState({
                errors,
            })
        }, 5000);
    }

    render() {
        const { membership = {}, errors = {} } = this.state
        return (
            <AddNewMembershipModalPortal>
                <div id={this.modalId} style={{zIndex:"1500"}} className="modal fade" role="dialog">
                    <div className={`modal-dialog ${this.props.modalSize || "modal-md"}`}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="modal-two-title">{lang.add_new_membership}</h4>
                            </div>
                            <div className="modal-body container-fluid">
                                <form>
                                    <table id="new-membership-form-table">
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <td>{lang.name}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="name"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.phone_number}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="phone_number"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.membership_card_no}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="membership_number"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>

                                            <MembershipBenefit membershipBenefits={this.state.membershipBenefits} membership={membership} onMembershipChange={this.onMembershipChange} />

                                            <tr><td className="table-section-row"><strong><u>{lang.starting_point}</u></strong></td></tr>
                                            <tr>
                                                <td>{lang.starting_point}</td>
                                                <td>:</td>
                                                <td>
                                                    <input className="form-control" name="starting_point" type="number" value={this.state.starting_point || ""} onChange={this.onOtherInfoChange} />
                                                </td>
                                            </tr>

                                            <tr><td className="table-section-row"><strong><u>{lang.other_info}</u></strong></td></tr>
                                            <tr>
                                                <td>{lang.point_gain_per_rm_1.replace('%currency%', this.props.app.state.currencyName)}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="earn_rate"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.redeem_rate_desc.replace('%currency%', this.props.app.state.currencyName)}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="redeem_rate"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.minimum_redeem_point_desc}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="minimum_redeem_point"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{lang.maximum_redeem_point_desc}</td>
                                                <td>:</td>
                                                <td>
                                                    <InputField
                                                        valueKey="maximum_redeem_point"
                                                        membership={membership}
                                                        onMembershipChange={this.onMembershipChange}
                                                        errors={errors}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                            <div className="modal-footer">
                                {
                                    this.state.isSaving ?
                                    <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "right" }} /> :
                                    this.getButtons()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </AddNewMembershipModalPortal>
        )
    }
}

class MembershipBenefit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedMemberBenefit: {},
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    onMembershipBenefitItemChange = (e, membershipBenefit) => {
        const checked = e.target.checked
        const selectedMemberBenefits = [...(this.props.membership.new_membership_benefits || [])]
        if (checked) {
            if (!selectedMemberBenefits.includes(membershipBenefit.id)) {
                selectedMemberBenefits.push(membershipBenefit.id)
            }
        }
        else {
            if (selectedMemberBenefits.includes(membershipBenefit.id)) {
                selectedMemberBenefits.splice(selectedMemberBenefits.indexOf(membershipBenefit.id), 1)
            }
        }

        this.props.onMembershipChange({
            target: {
                name: "new_membership_benefits",
                value: selectedMemberBenefits,
            }
        })
    }
    render() {
        if (!this.props.membershipBenefits || this.props.membershipBenefits.length == 0) {
            return null
        }
        return (
            <>
                {
                    this.props.membership.id && this.props.membership.id > 0 &&
                    <>
                        <tr>
                            <td className="table-section-row"><strong><u>{lang.existing_membership_benefits}</u></strong></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                <div className="gap-8" style={{display: "flex", columnGap: "10px"}}>
                                    {
                                        (this.props.membership.membership_benefits || []).filter(item => item.id > 0).map(membershipBenefit => {
                                            return (
                                                <ExistingMembershipBenefitItem
                                                    key={membershipBenefit.id}
                                                    membershipBenefit={membershipBenefit}
                                                    membership={this.props.membership}
                                                    selectedMemberBenefit={this.props.membership.membership_benefits || []}
                                                    onMembershipBenefitItemChange={(e) => this.onMembershipBenefitItemChange(e, membershipBenefit)}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            </td>
                        </tr>
                    </>
                }
                <tr>
                    <td className="table-section-row"><strong><u>{lang.add_membership_benefits}</u></strong></td>
                </tr>
                <tr>
                    <td colSpan={3}>
                        <div>
                            {
                                this.props.membershipBenefits.map(membershipBenefit => {
                                    return (
                                        <MembershipBenefitItem
                                            key={membershipBenefit.id}
                                            membershipBenefit={membershipBenefit}
                                            membership={this.props.membership}
                                            selectedMemberBenefit={this.props.membership.new_membership_benefits || []}
                                            onMembershipBenefitItemChange={(e) => this.onMembershipBenefitItemChange(e, membershipBenefit)}
                                        />
                                    )
                                })
                            }
                        </div>
                    </td>
                </tr>
            </>
        )
    }
}
const ExistingMembershipBenefitItem = (props) => {
    const {membershipBenefit, membership} = props
    let freeItem = membership.membership_free_items.find(item => item.membership_benefit_id == membershipBenefit.id)
    return (
        <div className="form-check" style={{display: "inline-block"}}>
            <div style={{display: "inline-block"}} className="text-center">
                <div className="label label-primary" style={{display: "inline-block"}}>
                    <span className="" style={{fontSize: "16px"}}>{membershipBenefit.name}</span>
                </div>
                <div>
                    <table className="table table-bordered table-condensed">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td className="text-left">Expire</td>
                                <td>{freeItem && freeItem.expire_at && moment(freeItem.expire_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') || "--"}</td>
                            </tr>
                            <tr>
                                <td className="text-left">Total</td>
                                <td>{freeItem && freeItem.total_quantity || 0}</td>
                            </tr>
                            <tr>
                                <td className="text-left">Balance</td>
                                <td>{freeItem && freeItem.balance_quantity || 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style={{fontSize: "12px"}}>Expire: {freeItem && freeItem.expire_at && moment(freeItem.expire_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') || "--"}</div>
            </div>
        </div>
    )
}
const MembershipBenefitItem = (props) => {
    const {membershipBenefit, onMembershipBenefitItemChange, selectedMemberBenefit} = props
    return (
        <div className="form-check">
            <label className="form-check-label">
                <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedMemberBenefit.includes(membershipBenefit.id)}
                    onChange={onMembershipBenefitItemChange}
                    name={membershipBenefit.name}
                />
                <span className="ml-2">{membershipBenefit.name}</span>
            </label>
        </div>
    )
}

class InputField extends Component {
    render() {
        const {membership} = this.props
        return (
            <>
                <input name={this.props.valueKey} className="form-control" type="text"
                       value={membership[this.props.valueKey] || ""} onChange={this.props.onMembershipChange}/>
                {
                    this.props.errors && this.props.errors[this.props.valueKey] &&
                    <div>
                        <span className="error-span">
                            {this.props.errors[this.props.valueKey]}
                        </span>
                    </div>
                }
            </>
        )
    }
}
AddNewMembershipModal.defaultProps = {
    customBody:null,
    message: "",
    buttonLayout: "default",
}
export default AddNewMembershipModal;